import requestApi from "@/api";
import { useUserStore } from "@/store";

// 把数组分为奇数和偶数组
export function splitArrayIndexesByOddEven(array) {
    const oddIndexes = [];
    const evenIndexes = [];

    for (let i = 0; i < array.length; i++) {
        array[i].index = i;
        if (i % 2 === 0) {
            evenIndexes.push(array[i]); // 偶数下标放入 evenIndexes
        } else {
            oddIndexes.push(array[i]);  // 奇数下标放入 oddIndexes
        }
    }

    return {
        odd: oddIndexes,
        even: evenIndexes
    };
}

// 手机加密
export function encryptPhoneNumber(phoneNumber) {
    const encrypted = phoneNumber.replace(/(\d{3})(\d+)(\d{4})/, (_, prefix, middle, suffix) => {
        const encryptedMiddle = '*'.repeat(middle.length); // 使用 * 替代中间部分的数字
        return `${prefix}${encryptedMiddle}${suffix}`;
    });

    return encrypted;
}

/**
 * 格式化倒计时的显示，小时:分钟:秒钟
 * @param {*} countdown 
 * @param {*} isWord 是否为中文格式
 * @returns 
 */
export const formattedTime = (countdown, isWord = false) => {
    countdown = Number(countdown)
    const hours = Math.floor(countdown / 3600)
    const minutes = Math.floor((countdown % 3600) / 60)
    const seconds = Math.floor(countdown % 60)

    if(countdown <= 0) {
      if(isWord) {
        return '0秒'
      }
        return '00:00'
    }

    if (hours > 0) {
      if(isWord) {
        return `${pad(hours)}时${pad(minutes)}分${pad(seconds)}秒`    
      }
        return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`
    } else {
      if(isWord) {
        return `${pad(minutes)}分${pad(seconds)}秒`
      }
        return `${pad(minutes)}:${pad(seconds)}`
    }
}

//格式化倒计时，分钟:秒钟.毫秒
export const formattedTimeWithDecimal = (countdown) => {
  const minutes = Math.floor(countdown / 60)
  const seconds = Math.floor(countdown % 60)
  const milliseconds = Math.floor((countdown % 1) * 100)

  if(countdown <= 0) {
    return '00:00.00'
  }
  return `${pad(minutes)}:${pad(seconds)}.${pad(milliseconds)}`
}

//格式化数字
export const pad = (value) => {
    return String(value).padStart(2, '0')
}

/**
 * 获取视频第一帧作为封面图
 * @param {视频文件} file 
 * @returns 
 */
export const getCoverImage = async (file) => {
    return new Promise((resolve) => {
      const video = document.createElement("video");
      video.crossOrigin = 'anonymous';
      video.autoplay = false;
      video.muted = false;
      video.src = URL.createObjectURL(file);
    
      video.onloadedmetadata = () => {
        video.currentTime = 1 / 25;
      };
  
      video.onseeked = () => {
        const canvas = document.createElement('canvas');
        let width = video.videoWidth;
        let height = video.videoHeight;
        canvas.width = width;
        canvas.height = height;
        canvas.getContext('2d').drawImage(video, 0, 0, width, height);
        let dataURL = canvas.toDataURL('image/jpeg');
        resolve(dataURL); // 解析 Promise 并返回封面图像的 URL
      };
    });
  };

//防抖函数
export const debounce = (func, delay, immediate) => {
  let timer;
  return function () {
    if (timer) clearTimeout(timer);
    if (immediate) {
      // 复杂的防抖函数
      // 判断定时器是否为空，如果为空，则会直接执行回调函数
      let firstRun = !timer;
      // 不管定时器是否为空，都会重新开启一个新的定时器,不断输入，不断开启新的定时器，当不在输入的delay后，再次输入就会立即执行回调函数
      timer = setTimeout(() => {
        timer = null;
      }, delay);
      if (firstRun) {
        func.apply(this, arguments);
      }
      // 简单的防抖函数
    } else {
      timer = setTimeout(() => {
        func.apply(this, arguments);
      }, delay);
    }
  };
}
 
/**
 * 节流函数
 * @param {*} fn 要执行的函数
 * @param {*} interval 时间间隔
 * @param {*} options 可选参数： leading第一次是否执行, trailing 最后一次是否执行
 * @returns 
 */
export const throttle = (fn, interval, options = { leading: false, trailing: true }) => {
  // 1.记录上一次的开始时间
  const { leading,trailing,resultCallback} = options
  let lastTime = 0
  let timer = null
 
  // 2.事件触发时, 真正执行的函数
  const _throttle = function (...args) {
      // 2.1.获取当前事件触发时的时间
      const nowTime = new Date().getTime()
      if (!lastTime && !leading) lastTime = nowTime
 
      // 2.2.使用当前触发的时间和之前的时间间隔以及上一次开始的时间, 计算出还剩余多长事件需要去触发函数
      const remainTime = interval - (nowTime - lastTime)
      if (remainTime <= 0) {
        if (timer) {
          clearTimeout(timer)
          timer = null
        }
 
        // 2.3.真正触发函数
        const result = fn.apply(this, args)
        if (resultCallback && typeof resultCallback === 'function') 
           resultCallback(result) //函数回调返回返回值
        // 2.4.保留上次触发的时间
        lastTime = nowTime
        return
      }
 
      if (trailing && !timer) {
        timer = setTimeout(() => {
          const result = fn.apply(this, args)
          if (resultCallback  && typeof resultCallback === 'function')  
           resultCallback(result) //函数回调返回返回值
          timer = null
          lastTime = !leading ? 0 : new Date().getTime()
        }, remainTime)
      }
  }
 
  _throttle.cancel = function () {
    if (timer) clearTimeout(timer)
    timer = null
    lastTime = 0
  }
 
  return _throttle
}

// blob转file
export const blobToFile = (blob, fileName, type) => {
  const file = new File([blob], fileName, type)
  return file
}

// 将 base64 转换为 Blob
export const dataURLToBlob = (base64) => {
  const byteString = atob(base64.split(",")[1]);
  const mimeString = base64.split(",")[0].split(":")[1].split(";")[0];
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);

  for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
  }
  let blob = new Blob([ab], { type: mimeString });
  let name = Date.now() + Math.floor(100000 + Math.random() * 900000) + '.png'
  const file = new File([blob], name,{ type: mimeString });
  return file;
  // return new Blob([ab], { type: mimeString });
}

//格式化数字人背景path
export const formattedPath = (path, ratio) => {
  let _path = ''
  let currentNum = ''
  for (let i = 0; i < path.length; i++) {
    const element = path[i]
    // 判断是否为数字
    if((!isNaN(Number(element)) || element == '.' || element == 'e' || element == '-') && element !== ' ') {
      currentNum += element
    } else {
      if(currentNum !== '0') {
        currentNum = String(Number(currentNum) * ratio)
        if(currentNum == '0') {
          currentNum = ''
        }
      }
      _path += currentNum + element
      currentNum = ''
    }
  }
  return _path
}

// 获取手机验证码行为验证
export const varifyCodeHandle = (successCallBack,failCallBack) => {
  let appid = '196244613'; // 腾讯云控制台中对应这个项目的 appid
  //生成一个滑块验证码对象
  let captcha = new TencentCaptcha(appid, function (res) {
    // 用户滑动结束或者关闭弹窗，腾讯返回的内容  
    console.log('验证完成',res)
    if (res.ret === 0) {
      successCallBack(res)
    } else {
      failCallBack()
    }
  });
  // 滑块显示
  captcha.show();
}

export const myGlobal = {
  curThrottle:null,
}

// 是否是vip true:是vip false: 不是vip
export const  isVipUser = async () => {
 const store = useUserStore()
 if (store.access && store.access.userId) {
  let headers = {
    'User-ID': store.access.userId,
    'Access-Token': store.access.accessToken,
    'APP-Name': 'jianpin_web_editor'
   }
   let result = {};
  await requestApi.mainModule.getUserInfo(headers).then((res) => {
      result = res.data.data;
    })
   if(result.vip_state === 'noVip') {
    return false
   } else if (result.vip_state === 'UserAccountVip') {
    // 是会员
    return true;
   }
 }

 return false;
}

// svg 转成png 的base64
export const getImageBase64ToSVGURL = (file) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = function(e) {
        const svgContent = e.target.result; // 获取SVG文件内容

        // 创建一个包含SVG内容的Blob对象
        const blob = new Blob([svgContent], { type: 'image/svg+xml' });

        // 创建一个空的Image对象
        const img = new Image();

        img.onload = function() {
            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;

            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);

            // 将Canvas转换为base64格式的PNG数据 

            const base64Data = canvas.toDataURL('image/png');
            resolve({base64Data: base64Data, width: img.width, height: img.height})
        };
        // 将SVG Blob对象加载到Image对象并触发载入事件
        img.src = URL.createObjectURL(blob);
    };

    // 以DataURL格式读取文件
    reader.readAsText(file);
 })
}